import React from "react";
import styled, { css } from "styled-components";
import { Radio, Typography } from "antd";
import { Controller } from "react-hook-form";
import SelectSkeleton from "lib/loader/jobType/selectSkeleton";
import { StyledTitle } from "pages/jobs/add";

const { Text } = Typography;

const JobTypeRadio = (props) => {
  const {
    jobTypeStatus,
    control,
    jobTypeData,
    setValue,
    joiErrors,
    trigger,
    getValues,
    watch,
    editMode,
  } = props;

  const formatJobType = (data) => {
    let jobTypeData = [];
    data?.map((d) => {
      const formatted = {
        label: d.name,
        value: d.id,
      };
      jobTypeData = [...jobTypeData, formatted];
    });
    return jobTypeData;
  };

  const [defaultJobTypeId, setDefaultJobTypeId] = React.useState(null);

  React.useEffect(() => {
    if (watch("job_type_id") !== null) {
      setDefaultJobTypeId(parseInt(watch("job_type_id")));
    }
  }, [jobTypeStatus === "success", watch("job_type_id")]);

  return (
    <>
      {jobTypeStatus === "loading" ||
      (editMode && defaultJobTypeId === null) ||
      jobTypeStatus !== "success" ? (
        <SelectSkeleton />
      ) : (
        <InputContainer>
          <StyledTitle>Job Type</StyledTitle>
          <>
            {editMode && defaultJobTypeId && (
              <Controller
                control={control}
                name="job_type_id"
                defaultValue={defaultJobTypeId}
                render={({ onChange, onBlur, value }) => {
                  return (
                    <StyledRadioGroup
                      error={joiErrors && joiErrors["job_type_id"]}
                      options={formatJobType(jobTypeData)}
                      optionType="button"
                      buttonStyle="solid"
                      defaultValue={defaultJobTypeId}
                      onChange={(e) => {
                        setValue("job_type_id", e.target.value, {
                          shouldDirty: true,
                        });
                        trigger("job_type_id");
                      }}
                    />
                  );
                }}
              />
            )}

            {!editMode && (
              <Controller
                control={control}
                name="job_type_id"
                defaultValue={getValues("job_type_id")}
                render={({ onChange, onBlur, value }) => {
                  return (
                    <StyledRadioGroup
                      error={joiErrors && joiErrors["job_type_id"]}
                      options={formatJobType(jobTypeData)}
                      optionType="button"
                      buttonStyle="solid"
                      defaultValue={getValues("job_type_id")}
                      onChange={(e) => {
                        setValue("job_type_id", e.target.value, {
                          shouldDirty: true,
                        });
                        trigger("job_type_id");
                      }}
                    />
                  );
                }}
              />
            )}
          </>

          {joiErrors && joiErrors["job_type_id"] && (
            <StyledError>
              <p>{joiErrors && joiErrors["job_type_id"].message}</p>
            </StyledError>
          )}
        </InputContainer>
      )}
    </>
  );
};

const StyledRadioGroup = styled(Radio.Group)`
  .ant-radio-button-wrapper {
    margin-top: ${(props) => props.theme.spacing[1]};
  }
  ${(props) =>
    props.error &&
    css`
      .ant-radio-button-wrapper {
        border: 1px solid ${(props) => props.theme.colors.red[600]};
        color: ${(props) => props.theme.colors.red[600]};
      }
    `};
`;

const StyledError = styled.span`
  color: ${(props) => props.theme.colors.red[600]};
  padding: 0;
  margin: 0;

  p {
    font-size: 0.8rem;
    margin: 0;
  }
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding-right: ${(props) => props.theme.spacing[3]};
  margin-bottom: ${(props) => props.theme.spacing[6]};
`;
export default JobTypeRadio;
